export const GMM_CANVAS_CLASS_NAME = 'gmm-canvas';
